import { render, staticRenderFns } from "./VendedorCreate.vue?vue&type=template&id=5fba8821&"
import script from "./VendedorCreate.vue?vue&type=script&lang=js&"
export * from "./VendedorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports